export default {"src":"/pro/_next/static/media/bera.c2fab6c4.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};